var React = require('react');

function ConcordIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.403 19.943a6.746 6.746 0 000-13.49l-.056 13.546M13.5 0C6.045 0 0 6.045 0 13.5S6.045 27 13.5 27"}));
}

ConcordIcon.defaultProps = {"width":"23","height":"27","viewBox":"0 0 23 27","fill":"none"};

module.exports = ConcordIcon;

ConcordIcon.default = ConcordIcon;
